import { Navigate, Outlet } from "react-router";
import { useAuth } from "../../lib/auth/useAuth";
import { useWaitlistStatus } from "../../lib/waitlist/useWaitlistStatus";

const E2E_BYPASS = import.meta.env.VITE_E2E_BYPASS_AUTH === "true";

function LoadingSpinner() {
  return (
    <div className="flex h-screen items-center justify-center bg-[var(--ink-50)]">
      <div
        role="status"
        aria-label="Loading"
        className="h-8 w-8 animate-spin rounded-full border-2 border-[var(--ink-200)] border-t-[var(--brand-600)]"
      />
    </div>
  );
}

export function AuthGate() {
  const { session, loading } = useAuth();
  const waitlist = useWaitlistStatus();

  // Test-only escape hatch: skip the gate so Playwright can hit the SPA
  // routes without a real Supabase session. useWaitlistStatus short-circuits
  // to "allowlisted" in the same mode.
  if (E2E_BYPASS) {
    return <Outlet />;
  }

  if (loading) return <LoadingSpinner />;
  if (!session) return <Navigate to="/login" replace />;

  // Session exists — now check the alpha allowlist. We wait for the RPC to
  // settle so a flashed "inbox → waitlist" redirect doesn't leak UI to a
  // non-allowlisted user.
  if (waitlist.loading) return <LoadingSpinner />;
  if (waitlist.status !== "allowlisted") {
    return <Navigate to="/waitlist-pending" replace />;
  }

  return <Outlet />;
}
